import React, { useEffect, useState } from "react"
import { ArrowLeftOutlined } from "@ant-design/icons"
import { Button, Image, Col, Row, Modal, Result } from "antd";
import { prMainLight, prMain } from "../../../themeConfig";
import moment from "moment";
import { apiStatusBudget } from "../../../utils/api";

const BudgetDetails = ({ details, setOpenDetails, refresh, setRefresh }) => {
    // const files = details.budgetParticipatoryFilesList.length 
    const [files, setFiles] = useState([])
    const [openModal, setOpenModal] = useState(false)
    const [success, setSuccess] = useState(false)
    const [error, setError] = useState(false)
    const [status, setStatus] = useState("")

    useEffect(() => {
        let array = []
        let tempObj = {}

        details.budgetParticipatoryFilesList.forEach(item => {
            switch (item.typeDocument) {
                case "Documento del Proyecto":
                    tempObj.id = "0"
                    tempObj.Path = item.Path
                    tempObj.name = "Documento del Proyecto"
                    break;
                case "Carta Anuencia":
                    tempObj.id = "1"
                    tempObj.Path = item.Path
                    tempObj.name = "Carta Anuencia"
                    break;
                case "Carta del Director":
                    tempObj.id = "2"
                    tempObj.Path = item.Path
                    tempObj.name = "Carta del Director"
                    break;
                case "Primer Anexo":
                    tempObj.id = "3"
                    tempObj.Path = item.Path
                    tempObj.name = "Primer Anexo"
                    break;
                case "Segundo Anexo":
                    tempObj.id = "4"
                    tempObj.Path = item.Path
                    tempObj.name = "Segundo Anexo"
                    break;
                default:
                    break;
            }
            array.push(tempObj)
            tempObj = {}
        });
        console.log(array.sort((a, b) => a.id.localeCompare(b.id)))
        setFiles(array.sort((a, b) => a.id.localeCompare(b.id)))
    }, [])

    const handleOpen = (textStatus) => {
        setStatus(textStatus)
        setOpenModal(true)
    }

    const handleClose = () => {
        setStatus("")
        setSuccess(false)
        setError(false)
        setOpenModal(false)
    }

    const handleChangeStatus = () => {

        apiStatusBudget(details.idBudgetParticipatory, status).then(() => {
            setRefresh(!refresh)
            handleClose()
            setOpenDetails(false)
        }).catch((e) => {
            console.log(e)
            setSuccess(false)
            setError(true)
        })
    }

    return (
        <div style={{ height: '90vh', overflowY: 'auto' }}>
            <div style={{ marginBottom: '4vh', display: 'flex', flexDirection: 'row' }}>
                <Button onClick={() => setOpenDetails(false)} type='text' icon={<ArrowLeftOutlined style={{ color: '#000', borderRadius: '16px' }} />}>
                </Button>
                <div style={{ display: 'flex', flexDirection: 'row', marginLeft: 'auto' }}>
                    <Button type="text" style={{ color: prMain }} onClick={() => handleOpen("Rechazado")}>
                        Rechazar
                    </Button>
                    <Button type="primary" onClick={() => handleOpen("Aceptado")}>
                        Aceptar
                    </Button>
                </div>
            </div>

            <Row>
                <Col style={colHeader} span={4}>Proyecto</Col>
                <Col style={colStyle} span={20}>{details.projectName}</Col>
            </Row>
            <Row>
                <Col style={colHeader} span={4}>Dirección</Col>
                <Col style={colStyle} span={20}>{details.address}</Col>
            </Row>
            {details.colonia &&

                <Row>
                    <>
                        <Col style={colHeader} span={4}>Colonia</Col>
                        <Col style={colStyle} span={20}>{details.colonia ? details.colonia.name : ""}</Col>
                    </>

                </Row>
            }
            <Row>

                <Col span={11}>
                    <Row>
                        <Col style={colHeader} span={8}>Código Postal</Col>
                        <Col style={colStyle} span={16}>{details.postcode ? details.postcode.postcode : ""}</Col>
                        <Col style={colHeader} span={8}>Votos</Col>
                        <Col style={colStyle} span={16}>{details.votes}</Col>
                    </Row>
                </Col>

                <Col span={11} offset={2}>
                    <Row>
                        <Col style={colHeader} span={8}>Creado por</Col>
                        <Col style={colStyle} span={16}>{details.nameUserCreated ?? ''}</Col>
                        <Col style={colHeader} span={8}>Fecha creación</Col>
                        <Col style={colStyle} span={16}>{moment(details.createdAt).format('lll')}</Col>

                    </Row>
                </Col>

            </Row>

            <Row style={{ display: 'flex', marginTop: '2vh' }}>
                {files.length > 0 && files.map((file, i) => (

                    <Col offset={2} style={{ marginBottom: '2vh' }}
                        xs={20} sm={10} md={9} lg={9} key={file['id']}>
                        <label style={{ backgroundColor: prMainLight, borderRadius: '16px 16px 0 0', textAlign: 'center' }} className='input-container' >
                            {file["name"]}
                        </label>
                        <div style={{ height: 175, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                            {
                                file['Path']

                                    ? <Image id={file['id']} src={`${file['Path']}`} alt={file['name']} height={175} style={{ objectFit: 'cover', borderRadius: '0 0 16px 16px' }} />
                                    : <Image
                                        style={{ objectFit: 'cover', borderRadius: '0 0 16px 16px' }}
                                        width={'100%'}
                                        height={175}
                                        src="error"
                                        fallback="data:image/png;base64,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"
                                    />
                            }
                            {/* <Button icon={<DeleteFilled />} disabled={state[i] === null} type='link' onClick={() => handleRemoveImage(i)}>Remover</Button> */}
                        </div>
                    </Col>
                ))

                }
            </Row>

            <Modal
                centered
                visible={openModal}
                closable={false}
                footer={null}
                onCancel={() => handleClose()}>
                {(!success && !error) &&
                    <Result
                        status={'info'}
                        title={status === "Aceptado" ? 'Aceptar proyecto' : 'Rechazar proyecto'}
                        subTitle={status === "Aceptado" ? `¿Desea aceptar el proyecto con folio ${details.idBudgetParticipatory}?` : `¿Desea rechazar el proyecto con folio ${details.idBudgetParticipatory}?`}
                        extra={[

                            <Button type='link' key='cancel' onClick={() => handleClose()}>Cancelar</Button>,
                            <Button type='primary' key='approve' onClick={() => handleChangeStatus()} >Continuar</Button>,
                        ]}
                    >

                    </Result>
                }
                {(success && !error) &&
                    <Result
                        status={'success'}
                        title={status === "Aceptado" ? 'Proyecto aceptado' : 'Proyecto rechazado'}
                        subTitle={`El proyecto con folio ${details.idBudgetParticipatory} ha sido ${status === "Aceptado" ? "aceptado" : "Rechazado"}`}
                        extra={[

                            <Button type='primary' key='cancel' onClick={() => handleClose()}>Cerrar</Button>,
                        ]}
                    >

                    </Result>
                }

                {(error && !success) &&
                    <Result
                        status={'error'}
                        title={`Error`}
                        subTitle={`Ha ocurrido un error al intentar ${status === "Aceptado" ? "aceptar" : "rechazar"} el proyecto con folio ${details.idBudgetParticipatory}.Por favor, intentar nuevamente`}
                        extra={[

                            <Button type='primary' key='cancel' onClick={() => handleClose()}>Cerrar</Button>,
                        ]}
                    >

                    </Result>
                }
            </Modal>

        </div>
    )
}

const colHeader = {
    border: 'solid 0px #000',
    minHeight: '30px',
    maxHeight: '50px',
    marginBottom: '15px',
    backgroundColor: prMainLight,
    borderRadius: '100px 0px 0px 100px',
    textAlign: 'center',
    verticalAlign: 'center',
    paddingTop: '4px',
    color: '#fff'

}

const colStyle = {
    border: `solid 1px ${prMainLight}`,
    maxHeight: '50px',
    marginBottom: '15px',
    // backgroundColor: prMainLight,
    borderRadius: '0px 100px 100px 0px',
    paddingLeft: '15px',
    paddingRight: '10px',
    paddingTop: '4px',
    // overflowX: 'hidden'
}

export default BudgetDetails